import { create } from 'zustand';

interface SphereState {
  scale: number;
  color: string;
  metalness: number;
  roughness: number;
  wireframe: boolean;
  
  // Actions to update the state
  setScale: (scale: number) => void;
  setColor: (color: string) => void;
  setMetalness: (metalness: number) => void;
  setRoughness: (roughness: number) => void;
  setWireframe: (wireframe: boolean) => void;
}

export const useSphereStore = create<SphereState>((set) => ({
  // Initial values
  scale: 1,
  color: '#8e44ad',
  metalness: 0.7,
  roughness: 0.3,
  wireframe: false,
  
  // Setter functions
  setScale: (scale) => set({ scale }),
  setColor: (color) => set({ color }),
  setMetalness: (metalness) => set({ metalness }),
  setRoughness: (roughness) => set({ roughness }),
  setWireframe: (wireframe) => set({ wireframe }),
})); 